import SelectField from '@components/Inputs/SelectField';
import { Typography, Checkbox, FormControlLabel } from '@mui/material';
import { Box } from '@mui/system';
import { values } from 'lodash';
import React from 'react';
import { AuditsTimePeriod } from 'types/audits';
import { DefaultExcludedActions } from 'utils/audits';

interface IAuditSelectTimePeriodProps {
	value: AuditsTimePeriod;
	excludedActions?: string[];
	onValueChange: (newValue: AuditsTimePeriod) => void;
	onExcludeChange: (excludedActions?: string[]) => void;
}

const AuditSelectTimePeriod: React.FC<IAuditSelectTimePeriodProps> = ({
	value,
	excludedActions,
	onValueChange,
	onExcludeChange
}) => {
	const timePeriods = React.useMemo(
		() =>
			values(AuditsTimePeriod).map((v) => ({
				value: v as string,
				label: intl.tr(`audit.timePeriod.${v}`)
			})),
		[]
	);

	return (
		<Box
			display="flex"
			flexDirection="row"
			data-testid="audit-select-time-period"
			justifyContent="center"
			alignItems="center"
			mb={1}
		>
			<Typography pr={1}>{intl.tr('audit.timePeriod.label')}</Typography>
			<SelectField
				sx={{ width: 160 }}
				data-testid="audit-select-time-period-field"
				options={timePeriods}
				value={value}
				onChange={(e) => onValueChange(e.target.value as AuditsTimePeriod)}
			/>
			<FormControlLabel
				sx={{ marginLeft: 2 }}
				id="excluded-actions-filter-id"
				label={intl.tr('audit.verbose.label')}
				control={
					<Checkbox
						id="excluded-actions-filter-id"
						aria-label={intl.tr('audit.verbose.label')}
						checked={!((excludedActions?.length ?? 0) > 0)}
						onChange={(e) =>
							onExcludeChange(
								!e.target.checked ? DefaultExcludedActions : undefined
							)
						}
						data-testid="excluded-actions-filter-cb"
					/>
				}
			/>
		</Box>
	);
};
AuditSelectTimePeriod.defaultProps = {
	excludedActions: undefined
};

export default AuditSelectTimePeriod;
